import React, { useEffect, useState } from "react";
import Table from "../../../../Components/Table";
import { format } from "date-fns";
import { ButtonPrimary } from "../../../../Components/Button";
import { Link } from "react-router-dom";
import { FRONTEND as CORPORATE_ROUTES } from "../../../../Router/corporate_routes";
import { FRONTEND as PUBLIC_ROUTES } from "../../../../Router/public_routes";
import { BOOKED_EVENT_STATUS } from "../../../../constants";

const mapEnquiryToTemplate = enquiry => {
  if (enquiry) {
    let venueIds = [];
    enquiry.enquiry_venue_datas &&
      enquiry.enquiry_venue_datas.map(vd => {
        venueIds.push(vd.venue_id);
      });
    console.log(enquiry);
    return {
      enquiry: {
        event_name: enquiry.event_name + " (New)",
        number_of_delegates: enquiry.number_of_delegates,
        maximum_number_of_delegates: enquiry.maximum_number_of_delegates,
        room_style_id: enquiry.room_style_id,
        bedrooms_required: enquiry.bedrooms_required,
        back_projection: enquiry.back_projection,
        syndicate_room: enquiry.syndicate_room,
        syndicate_room_notes: enquiry.syndicate_room_notes,
        exhibition_space: enquiry.exhibition_space,
        exhibition_space_notes: enquiry.exhibition_space_notes,
        private_dining: enquiry.private_dining,
        private_dining_notes: enquiry.private_dining_notes,
        any_equipment: enquiry.any_equipment,
        any_equipment_notes: enquiry.any_equipment_notes,
        event_timings: enquiry.event_timings,
        additional_notes: enquiry.additional_notes,
        department_id: enquiry.department_id,
        agency: enquiry.agency_id,
        client_company: enquiry.client_company,
        client: enquiry.client,
        brief_location: enquiry?.brief_preferences?.location,
        brief_event_type: enquiry?.brief_preferences?.event_type,
        brief_budget: enquiry?.brief_preferences?.budget,
        syndicate_rooms: enquiry?.brief_preferences?.syndicate_rooms,
      },
      venueIds: venueIds,
    };
  }
  return {};
};

const renderButtons = (bookedEvent, isCorporate = true) => {
  return (
    <>
      <ButtonPrimary
        classes={"mx-2 w-30 text-xs"}
        Element={Link}
        to={{
          pathname: isCorporate
            ? CORPORATE_ROUTES.PROPOSALS.REQUEST
            : PUBLIC_ROUTES.ENQUIRY.NEW,
          state: { template: mapEnquiryToTemplate(bookedEvent?.enquiry) },
        }}
      >
        New Enquiry from Template
      </ButtonPrimary>
    </>
  );
};

const TemplatesListTable = ({
  bookedEvents = [],
  isCompanyAccount,
  isCorporate,
}) => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(getBookedEventsData());
  }, []);

  const getBookedEventsData = () => {
    return bookedEvents.map(bookedEvent => {
      if (bookedEvent.data) {
        let confirmedData = bookedEvent.data.enquiry_venue_datas;
        let enquiry = bookedEvent.data.enquiry;
        return {
          event_date: () => (
            <span className="text-xs">
              {format(bookedEvent.data.event_date_from, "DD/MM/YYYY")} -{" "}
              {format(bookedEvent.data.event_date_to, "DD/MM/YYYY")}
            </span>
          ),
          id: () => (
            <span className="font-bold">
              {enquiry && enquiry.client_company
                ? enquiry.client_company.code
                : ""}
              {enquiry.id}
            </span>
          ),
          event_name: () => <span>{enquiry.event_name}</span>,
          status: () => (
            <>
              {isCompanyAccount &&
              bookedEvent.data.event_status &&
              parseInt(bookedEvent.data.event_status.code) ===
                BOOKED_EVENT_STATUS.PENDING_INVOICE ? (
                <span className="p-1 bg-blue-light text-xs">Completed</span>
              ) : (
                <span className="p-1 bg-blue-light text-xs">
                  {bookedEvent.data.event_status &&
                    bookedEvent.data.event_status.name}
                </span>
              )}
            </>
          ),
          download: (
            <div className="flex">
              {renderButtons(bookedEvent.data, isCorporate)}
            </div>
          ),
        };
      } else {
        return {};
      }
    });
  };

  return <Table admin headers={tableHeaders} data={tableData} />;
};

const tableHeaders = [
  {
    key: "id",
    display: "ID",
  },
  {
    key: "event_date",
    display: "Event Date",
  },
  {
    key: "event_name",
    display: "Event Title",
  },
  {
    key: "status",
    display: "Status",
  },
  {
    key: "download",
    display: "",
  },
];

export default TemplatesListTable;
